export { default as StrategyMapHeaderMetricBlock } from './StrategyMapHeaderMetricBlock';
